(function () {
    'use strict';

    angular
        .module('soopkitchenApp')
        .controller('PlanningDeleteController', PlanningDeleteController);

    PlanningDeleteController.$inject = ['$rootScope', '$sce','$controller', '$uibModalInstance', 'parameters', 'Planning', 'SoopkitchenUtils'];

    function PlanningDeleteController($rootScope, $sce, $controller,$uibModalInstance, parameters, Planning, SoopkitchenUtils) {
        
        var vm = this;

        angular.extend(this, $controller('SoopkitchenDialogController', {
            "title": 'Confirm delete operation', $sce: $sce, $uibModalInstance:$uibModalInstance}));
        
        /**** Properties ****/
        vm.label = parameters.label;
        vm.planType = parameters.planType;
        vm.saveText = "Delete";

        /**** Methods ****/
        vm.save = confirmDelete;

        function confirmDelete() {
            Planning.delete(
                {
                    planType: vm.planType,
                    id: vm.label
                },
                function successCallback() {
                    SoopkitchenUtils.invokeSweetAlert('Plan Deleted', vm.label + ' has been deleted', 'success', function () {
                        $rootScope.$broadcast('deletedPlan');
                        $uibModalInstance.dismiss('cancel');
                    })
                },
                function errorCallback(response) {
                    SoopkitchenUtils.prettyError(response);
                })
        }
    }
})();
